import {createAsyncThunk} from "@reduxjs/toolkit";
import {emailVerificationAPI, ICheckCodeData, ISendCodeData} from "../api";
import {thunkHandlers} from "../../../store/thunkHandlers";

export const fetchSendVerificationCode = createAsyncThunk(
    "emailVerification/sendCode",
    async (data: ISendCodeData, {dispatch, rejectWithValue}) => {
        try {
            return await emailVerificationAPI.sendCode(data);
        } catch (e) {
            return rejectWithValue(thunkHandlers.error(e, dispatch));
        }
    },
);

export const fetchCheckVerificationCode = createAsyncThunk(
    "emailVerification/checkCode",
    async (data: ICheckCodeData, {dispatch, rejectWithValue}) => {
        try {
            await emailVerificationAPI.checkCode(data);
            // возвращаем email — нужен для сравнения в RegisterForm
            return {email: data.email};
        } catch (e) {
            return rejectWithValue(thunkHandlers.error(e, dispatch));
        }
    },
);